const state = {
  isShow: false,
}

const mutations = {
  show(state) {
    document.body.style.overflow = 'hidden'
    state.isShow = true

  },
  hide(state) {
    document.body.style.overflow = 'auto'
    state.isShow = false
  },
}

const actions = {


}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
